<template>
  <div class="sblx-container">
    <el-row class="tcf-row">
      <el-col :span="6" class="card" style="padding-right: 10px">
        <div class="card-body">
          <div class="card-title">
            一级分类
            <div class="right">
              <el-button type="text" size="mini" icon="el-icon-plus" @click="addData(0)">添加分类</el-button>
            </div>
          </div>
          <el-table
            :data="tableOne"
            v-loading="loading"
            element-loading-text="数据加载中"
            :show-header="false"
            size="mini"
            :row-class-name="oneClassName"
            :row-style="{cursor: 'pointer'}"
            @row-click="openOneDetails"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="名称"
              show-overflow-tooltip
              min-width="100">
            </el-table-column>
            <el-table-column
              align="right"
              width="160"
              label="操作">
              <template slot-scope="scope">
                <el-button @click.native.stop="editData(scope.row,0)" size="mini" type="text">编辑</el-button>
                <el-button @click.native.stop="delData(scope.row,0)" size="mini" type="text">删除</el-button>
                <el-button size="mini" @click.native.stop="unfold(scope.row,0)" type="text">展开 <i class="el-icon-caret-right"></i></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="6" class="card" style="padding-right: 10px">
        <div class="card-body">
          <div class="card-title">
            二级分类
            <div class="right">
              <el-button type="text" size="mini" icon="el-icon-plus" @click="addData(1)">添加分类</el-button>
            </div>
          </div>
          <el-table
            :data="tableTwo"
            v-loading="loading"
            element-loading-text="数据加载中"
            :show-header="false"
            size="mini"
            :row-class-name="twoClassName"
            :row-style="{cursor: 'pointer'}"
            @row-click="openTwoDetails"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="名称"
              show-overflow-tooltip
              min-width="100">
            </el-table-column>
            <el-table-column
              align="right"
              width="160"
              label="操作">
              <template slot-scope="scope">
                <el-button @click.native.stop="editData(scope.row,1)" size="mini" type="text">编辑</el-button>
                <el-button @click.native.stop="delData(scope.row,1)" size="mini" type="text">删除</el-button>
                <el-button size="mini" @click.native.stop="unfold(scope.row,1)" type="text">展开 <i class="el-icon-caret-right"></i></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="12" class="card">
        <div class="card-body">
          <div class="card-title">
            设备列表
            <div class="right">
              <el-button type="text" size="mini" icon="el-icon-plus" @click="addData(2)">添加设备</el-button>
            </div>
          </div>
          <el-table
            :data="tableThr"
            v-loading="loading"
            element-loading-text="数据加载中"

            style="width: 100%">
            <el-table-column
              label="#"
              width="44">
              <template slot-scope="scope">
                <el-image
                  style="height: 20px"
                  :src="scope.row.imgurl"
                  fit="cover"
                  :preview-src-list="[scope.row.imgurl]"></el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              show-overflow-tooltip
              width="140">
            </el-table-column>
            <el-table-column
              prop="mode"
              label="型号"
              show-overflow-tooltip
              min-width="100">
            </el-table-column>
            <el-table-column
              align="right"
              width="120"
              label="操作">
              <template slot-scope="scope">
                <el-button @click="editData(scope.row,2)" size="mini" type="text">编辑</el-button>
                <el-button @click="delData(scope.row,2)" size="mini" type="text">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="340px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="rulesEditForm"  label-position="right" label-width="50px" size="mini">
        <el-form-item v-if="editForm.type===2" label="图片" prop="img">
          <span style="color:#99a9bf;font-size: 12px;"><i class="el-icon-info"></i> 建议尺寸1:1正方形PNG格式</span>
          <SingleImg v-model="editForm.img" :key="imgKey" :oldurl="oldimgurl" :size="[120,120]"></SingleImg>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name" maxlength="100" placeholder="请输入名称" show-word-limit></el-input>
        </el-form-item>
        <el-form-item v-if="editForm.type===2" label="型号" prop="mode">
          <el-input v-model="editForm.mode" maxlength="200" placeholder="请输入型号" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editLoading" @click="SubEditForm('editForm')">提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import SingleImg from '@/components/upload/SingleImg'
import { getLifeDeviceTypeList, editLifeDeviceType, delLifeDeviceType } from '@/api/work'
export default {
  name: 'sblx',
  computed: {
    user: getUser
  },
  components: {
    SingleImg
  },
  data() {
    return {
      loading: false,
      oneid: 0,
      twoid: 0,
      imgKey: '',
      oldimgurl: '',
      tableOne: [],
      tableTwo: [],
      tableThr: [],
      editTitle: '',
      editVisible: false,
      editLoading: false,
      editForm: {
        type: 0,
        id: null,
        name: '',
        pid: 0,
        xuhao: 1,
        img: null,
        imgid: '',
        mode: ''
      },
      rulesEditForm: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        img: [{ required: true, message: '请上传图片', trigger: 'change' }],
        mode: [{ required: true, message: '请输入设备型号', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      getLifeDeviceTypeList().then(response => {
        this.tableOne = response.data
        this.tableTwo = []
        this.tableThr = []
        if (this.tableOne.length>0) {
          if (this.oneid === 0) {
            const one = this.tableOne[0]
            this.oneid = one.id
            this.tableTwo = one.twolst
            if (one.twolst.length>0) {
              const two = one.twolst[0]
              this.twoid = two.id
              this.tableThr = two.devicelst
            }
          } else {
            for(let i = 0; i< this.tableOne.length; i++){
              if (this.oneid === this.tableOne[i].id) {
                this.tableTwo = this.tableOne[i].twolst
                if (this.tableTwo.length>0) {
                  let ishavetwo = false
                  if(this.twoid !== 0) {
                    for (let j=0;j<this.tableTwo.length;j++) {
                      if (this.twoid === this.tableTwo[j].id) {
                        this.tableThr = this.tableTwo[j].devicelst
                        ishavetwo = true
                      }
                    }
                  }
                  if(!ishavetwo) {
                    const two = this.tableTwo[0]
                    this.twoid = two.id
                    this.tableThr = two.devicelst
                  }
                } else {
                  this.twoid = 0
                }
                break
              }
            }
          }
        } else {
          this.oneid = 0
          this.twoid = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    openOneDetails(row) {
      this.unfold(row,0)
    },
    openTwoDetails(row) {
      this.unfold(row,1)
    },
    unfold(row,n) {
      if (n === 0) {
        if (this.oneid === row.id) {
          return
        }
        this.oneid = row.id
        this.tableTwo = row.twolst
        if (this.tableTwo.length > 0) {
          const two = this.tableTwo[0]
          this.twoid = two.id
          this.tableThr = two.devicelst
        } else {
          this.twoid = 0
          this.tableThr = []
        }
      } else {
        if (this.twoid === row.id) {
          return
        }
        this.twoid = row.id
        this.tableThr = row.devicelst
      }
    },
    addData(n) {
      if (n === 0) {
        this.editTitle = '添加一级分类'
        this.editForm.pid = 0
      } else if(n === 1) {
        if (this.oneid === 0) {
          this.$message({
            message: '请选择一级分类',
            type: 'warning'
          })
          return
        }
        this.editTitle = '添加二级分类'
        this.editForm.pid = this.oneid
      } else {
        if (this.twoid === 0) {
          this.$message({
            message: '请选择二级分类',
            type: 'warning'
          })
          return
        }
        this.editTitle = '添加设备'
        this.editForm.pid = this.twoid
      }
      this.editForm.type = n
      this.editForm.id = 0
      this.editForm.name = ''
      this.editForm.mode = ''
      this.editForm.img = null
      this.editForm.imgid = ''
      this.oldimgurl = ''
      this.imgKey = new Date().getTime()
      this.editVisible = true
    },
    editData(row,n) {
      if (n === 0) {
        this.editTitle = '编辑一级分类'
        this.editForm.pid = 0
        this.editForm.id = row.id
        this.editForm.img = null
        this.editForm.imgid = ''
        this.oldimgurl = ''
      } else if(n === 1) {
        this.editTitle = '编辑二级分类'
        this.editForm.pid = this.oneid
        this.editForm.id = row.id
        this.editForm.img = null
        this.editForm.imgid = ''
        this.oldimgurl = ''
      } else {
        this.editTitle = '编辑设备'
        this.editForm.pid = this.twoid
        this.editForm.id = row.id
        this.editForm.img = { imgid: row.imgid, imgurl: row.imgurl }
        this.editForm.imgid = row.imgid
        this.oldimgurl = row.imgurl
        this.imgKey = new Date().getTime()
      }
      this.editForm.type = n
      this.editForm.name = row.name
      this.editForm.mode = row.mode
      this.editVisible = true
    },
    SubEditForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editLoading) {
            this.editLoading = true
            if (this.editForm.type === 2) {
              this.editForm.imgid = this.editForm.img.imgid
            }
            editLifeDeviceType(this.editForm).then(response => {
              this.$message({
                type: 'success',
                message: response.msg
              })
              this.getData()
              this.editVisible = false
              this.editLoading = false
            }).catch(() => {
              this.editLoading = false
              return false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    delData(row,n) {
      let t = '一级分类'
      if (n === 1) {
        t = '二级分类'
      } else if(n === 2) {
        t = '设备'
      }
      this.$confirm(`确认删除此${t}吗?`, `删除${t}`, {
        type: 'warning'
      }).then(() => {
        this.editForm.id = row.id
        delLifeDeviceType(this.editForm).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        }).catch(() => {
          return false
        })
      }).catch(() => {})
    },
    oneClassName({row, rowIndex}) {
      if (row.id === this.oneid) {
        return 'change-row'
      } else {
        return ''
      }
    },
    twoClassName({row, rowIndex}) {
      if (row.id === this.twoid) {
        return 'change-row'
      } else {
        return ''
      }
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
